// extracted by mini-css-extract-plugin
module.exports = {"notFirstLevelcard":"styles_notFirstLevelcard__14qS9"};